import React from 'react';
import PropTypes from 'prop-types';
import AccountShowField from 'components/show/AccountShowField';
import Actions from 'components/ui/general/Actions';
import ActiveStateButton from 'components/button/ActiveStateButton';
import apiClient from 'clients/apiClient';
import BooleanField from 'components/show/BooleanField';
import Breadcrumbs from 'components/layout/Layout/Breadcrumbs';
import Column from 'components/ui/show/Column';
import ComputedPriceField from 'components/show/ComputedPriceField';
import config from 'helpers/config';
import DateTimeUTCTextField from 'components/show/DateFields/DateTimeUTCTextField';
import DeleteModalButton from 'components/button/DeleteModalButton';
import EditButton from 'components/button/EditButton';
import ExportButton from 'components/button/actions/ExportButton';
import Header from 'components/ui/general/Header';
import InnerColumn from 'components/ui/show/InnerColumn';
import Section from 'components/ui/general/Section';
import ShowButton from 'components/button/ShowButton';
import TextField from 'components/show/TextField';
import Title from 'components/ui/general/Title';
import theme from 'theme/theme';
import translate from 'components/hoc/translate';
import utils from 'helpers/utils';
import { ImageIcon } from 'assets/materialIcons/materialIcons';
import { deleteDiscountFailure, deleteDiscountSuccess } from 'store/actions/discounts/deleteDiscounts';
import { updateDiscountFailure, updateDiscountSuccess } from 'store/actions/discounts/updateDiscounts';

const enrichedUpdateDiscountSuccess = (payload) => {
    return (response) => {
        return updateDiscountSuccess(payload, response);
    };
};

const showAmount = (record, locale) => {
    if (record.amount) {
        return (
            <div>
                <ComputedPriceField
                    currency={ record.currency }
                    label='resources.discounts.fields.amount'
                    locale={ locale }
                    value={ record.amount }
                />
            </div>
        );
    } if (record.percentage) {
        return (
            <div>
                <TextField
                    label='resources.discounts.fields.percentage'
                    value={ `${ record.percentage * 100 }%` }
                />
            </div>
        );
    }

    return null;
};

class DiscountsShow extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            loading: true,
            discount_codes_count: null,
        };
    }

    componentDidMount() {
        const {
            id,
            record,
        } = this.props;

        const params = {
            discount_id: [
                id,
            ],
            sort_by: 'created_at',
            sort_direction: 'desc',
        };

        if (!utils.has(record, 'uses_discount_codes') || record.uses_discount_codes) {
            const url = `${ config.getApiBaseUrl() }/discount-codes`;

            apiClient.read(url, params).then((response) => {
                this.setState({
                    loading: false,
                    discount_codes_count: response.total,
                });
            });
        }
    }

    render() {
        const {
            handleExport,
            id,
            locale,
            record,
            resource,
            translate,
        } = this.props;
        const {
            discount_codes_count,
        } = this.state;

        const breadcrumbs = [
            {
                label: translate('resources.discounts.title'),
                link: '/discounts',
            },
            {
                label: record.title,
            },
        ];

        const discountCodesButtonLabel = translate('resources.discounts.forms.manage_discount_codes');

        return (
            <div>
                <Breadcrumbs breadcrumbs={ breadcrumbs } />

                <Header>
                    <Title title={ record.title }/>

                    <Actions>
                        <ExportButton onClick={ handleExport } />

                        {discount_codes_count === null ? null : <ShowButton
                            label={ `${ discountCodesButtonLabel } (${ discount_codes_count })` }
                            url={ `/discounts/${ record.id }/discount-codes` } />}

                        <EditButton
                            icon={ <ImageIcon color={ theme.palette.doveGray } /> }
                            primary={ false }
                            record={ record }
                            url={ `/${ resource }/${ id }` }
                        />

                        <ActiveStateButton
                            active={ record.is_enabled }
                            failureAction={ updateDiscountFailure }
                            id={ id }
                            parameter='is_enabled'
                            resource='discounts'
                            role='discount'
                            successAction={ enrichedUpdateDiscountSuccess({
                                id: id,
                            }) }
                        />

                        <DeleteModalButton
                            successAction={ deleteDiscountSuccess }
                            failureAction={ deleteDiscountFailure }
                            id={ id }
                            resource='discounts'
                        />
                    </Actions>
                </Header>

                <Section>
                    <Column title={ translate('resources.discounts.forms.general') }>
                        <InnerColumn>
                            <DateTimeUTCTextField
                                label='resources.discounts.fields.created_at'
                                value={ record.created_at }
                            />

                            {showAmount(record, locale)}

                            <BooleanField
                                label='resources.discounts.fields.end_processing'
                                value={ record.end_processing ? record.end_processing : false }
                            />

                            <TextField
                                label='resources.discounts.fields.priority'
                                value={ record.priority }
                            />

                            <BooleanField
                                label='resources.discounts.fields.uses_discount_codes'
                                value={ record.uses_discount_codes }
                            />
                        </InnerColumn>
                    </Column>
                    {record.account_id &&
                        <Column title={ translate('resources.discounts.forms.account') }>
                            <InnerColumn>
                                <AccountShowField
                                    value={ record.account_id }
                                />
                            </InnerColumn>
                        </Column>
                    }
                </Section>
            </div>
        );
    }
}

DiscountsShow.propTypes = {
    handleExport: PropTypes.func.isRequired,
    id: PropTypes.number,
    locale: PropTypes.string,
    record: PropTypes.object,
    resource: PropTypes.string.isRequired,
    translate: PropTypes.func.isRequired,
};

export default translate(DiscountsShow);



// WEBPACK FOOTER //
// ./src/pages/discounts/show/DiscountsShow.js